import { createContext } from "react";
import { IConfirmationModalState } from "./ConfirmationModalProvider";

const ConfirmationModalContext = createContext({
    isOpen: false,
    openConfirmationModal: (confirmationModalState: IConfirmationModalState) => {},
});

export default ConfirmationModalContext;
